<template>
  <Panel :isLoading="isLoading">
    <h2 slot="title">Infection Case Frequency
      <div style="display: flex; margin-left:auto;align-items:center;gap: 1rem">
        <el-radio-group v-model="graphSection.groupBy" size="small" @change="getSummary">
            <el-radio-button label="Infection Site"></el-radio-button>
            <el-radio-button label="Unit"></el-radio-button>
            <el-radio-button label="Facility"></el-radio-button>

          </el-radio-group>

        <!-- <el-radio-group v-model="graphSection.timeScale" size="small" @change="getSummary">
            <el-radio-button label="Week"></el-radio-button>
            <el-radio-button label="Day"></el-radio-button>
          </el-radio-group> -->
      </div>
    </h2>
    <LineChart title="" :series="graphSection.series" :xAxisCategories="graphSection.xAxis" :yAxisTitle="graphSection.yAxis" />
  </Panel>
</template>

<script>
import moment from "moment";
import LineChart from "../Shared/LineChart.vue";
import Panel from "./Panel.vue";

export default {
  name: "FrequencyChart",
  props: ["filters"],
  components: {
    Panel,
    LineChart
  },
  watch: {
    filters() {
      this.getSummary();
    },
    'graphSection.timeScale'() {
      this.getSummary();
    },
    'graphSection.groupBy'() {
      this.getSummary();
    },
  },
  data() {
    return {
      isLoading: true,
      graphSection: {
        loading: true,
        groupOptions: {
          Medication: "medication",
          "Infection Site Type": "infectionSiteSubType",
          "Infection Site": "infectionSite",
          "Primary Organism": "primaryOrganism",
          "Individual Type": "individualType",
          Facility: "facility",
          Unit: "unit"
        },
        groupBy: "Infection Site",
        timeScale: "Week",
        series: [],
        title: "Infection Case Frequency",
        yAxis: "Frequency",
        xAxis: [],
        plotLines: [],
        customizations: {
          legend: {
            enabled: true
          },
          plotOptions: {
            series: {
              dataLabels: {
                format: "{y}"
              }
            },
            column: {
              stacking: undefined
            }
          }
        },
        chartType: "stackedColumn",
        infectionSiteColorPalette: {
          Respiratory: "#0a6fbe",
          GI: "#0abe4a",
          BSI: "#cf3838",
          UTI: "#dce200",
          Skin: "pink",
          ARO: "black",
          AUTI: "orange",
          EENT: "purple",
          Other: "grey",
          Screening: "brown"
        }
      }
    };
  },
  methods: {
    generateColumnLineGraphData(groupedTotals, timePeriods) {
      let orderedTotals = [...groupedTotals.entries()];
      this.graphSection.xAxis = timePeriods;

      this.graphSection.series = orderedTotals.flatMap(([name, periods]) => {
        const color = this.graphSection.groupBy === "Infection Site" ? this.graphSection.infectionSiteColorPalette[name] : undefined;
        return {
          name,
          color,
          data: timePeriods.map(period => periods[period].count),
          dataLabels: {
            enabled: true
          }
        };
      });
    },
    createSummary(summary) {
      const timeScale = this.graphSection.timeScale;
      const formatTime = {
        Day: record => `${record.dategroup}-${record.year}`,
        Week: record => `W${record.dategroup}-${record.year}`,
        Month: record => `${record.year}-${`${record.dategroup}`.padStart(2, "0")}`,
        Quarter: record => `Q${record.dategroup}-${record.year}`,
        Year: record => `${record.year}`
      };

      const allTimePeriods = new Map();
      const groupKey = this.graphSection.groupOptions[this.graphSection.groupBy];

      const convertAndGroup = record => {
        const row = {
          time: formatTime[timeScale](record),
          group: record[groupKey],
          count: record.total,
          data: record
        };
        allTimePeriods.set(row.time, { count: 0 });
        return row;
      };
      const orderedCounts = summary.map(convertAndGroup);
      const getSummaryDefaults = () => JSON.parse(JSON.stringify(Object.fromEntries(allTimePeriods)));

      let groupedTotals = new Map();

      orderedCounts.forEach(row => {
        if (!groupedTotals.has(row.group)) {
          groupedTotals.set(row.group, getSummaryDefaults());
        }
        let values = groupedTotals.get(row.group);
        values[row.time] = values[row.time] || { count: 0 };
        values[row.time].count += row.count;
        groupedTotals.set(row.group, values);
      });
      return [groupedTotals, [...new Set(orderedCounts.map(c => c.time))]];
    },
    async getSummary() {
      this.isLoading = true;
      const filters = {
        ...this.filters,
        onsetDateFrom: moment()
          .subtract(30, "days")
          .startOf("day")
          .format(),
        onsetDateTo: moment()
          .endOf("day")
          .format(),
        groupBy: this.graphSection.groupOptions[this.graphSection.groupBy],
        timeScale: this.graphSection.timeScale.toLowerCase(),
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
      };

      if (!filters.unitIds.length) {
        delete filters.unitIds
      }

      const summary = await this.$http
        .post(`${window.CONFIG.infection_api}/frequency/summary`, { ...filters })
        .then(response => response.body)
        .catch(() => {
          return [];
        });
      const [groups, periods] = this.createSummary(summary);
      this.generateColumnLineGraphData(groups, periods);
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>

</style>
